import React, { useRef, useState } from "react";
import Button from "../UniversalComponents/DefaultButton";
import { ReactComponent as AddField } from "../../assets/images/icons/AddField.svg";
import AddFieldDrawer from "../GlobalFeature/Table/AddFieldDrawer";
import StepperComponent from "../UniversalComponents/StepperComponent";

const VendorSections = () => {
  const stepperRef = useRef();
  const [isOpenAddSection, setIsOpenAddSection] = React.useState(false);

  const handleAddSection = () => {
    setIsOpenAddSection(true);
  };

  const handleCloseDrawer = () => {
    setIsOpenAddSection(false);
  };

  return (
    <>
      <div className="p-3">
        <div className="flex justify-between border-b border-gray-300 pb-2 mb-4">
          <h3 className="text-14 text-[#666] font-500">New Section</h3>
          <Button
            className="px-2 flex items-center whitespace-nowrap gap-x-2 w-fit !text-14 !font-400"
            onClick={handleAddSection}
          >
            <AddField />
            Add Section
          </Button>
        </div>
      </div>

      {isOpenAddSection && <AddFieldDrawer open={isOpenAddSection} onClose={handleCloseDrawer} />}
    </>
  );
};

export default VendorSections;
